export default __webpack_public_path__ + "static/media/how-it-works-background.47f168b2.svg";